<template>
  <div id="app" class="container-fluid">
    <!-- Header (UNCHANGED) -->
    <full_oncology_head :visit_id="visit_id" />

    <!-- Main Content -->
    <div class="main-content">
      <div class="card investigations-card">
        <div class="investigations-header">
          <div class="header-left">
            <i class="fas fa-x-ray header-icon"></i>
            <div>
              <h3>Investigations</h3>
              <small class="text-muted">
                Laboratory tests for this patient
              </small>
            </div>
          </div>

          <button
            class="btn btn-outline-primary"
            @click="showCreatePatientService"
          >
            <i class="fas fa-plus"></i> Add Investigation
          </button>
        </div>

        <div v-if="loading">
          <loader />
        </div>

        <div v-if="!loading" class="card-body">
          <div class="table-responsive">
            <table class="table investigations-table">
              <thead>
                <tr>
                  <th scope="col">Test Number</th>
                  <th scope="col">Test Name</th>
                  <th scope="col">Status</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="service in services" :key="service.id">
                  <th scope="row">{{ service.id }}</th>
                  <td style="color: black">{{ service.service_name }}</td>
                  <td>
                    <span
                      v-if="service.attended == '0' || service.attended == null"
                      >Pending...</span
                    >
                    <span
                      v-if="service.attended == '1' || service.attended == 1"
                      >Ongoing...</span
                    >
                    <span
                      v-if="service.attended == '2' || service.attended == 2"
                      >Completed</span
                    >
                  </td>
                  <td class="text-end">
                    <a
                      v-if="
                        open_service(
                          service.is_invoice,
                          service.is_paid,
                          cash_bills_behavior
                        )
                      "
                      :href="'/lab-details/' + service.id"
                      class="btn btn-sm btn-info button-touch"
                    >
                      Details</a
                    >.
                    <span
                      v-if="
                        !open_service(
                          service.is_invoice,
                          service.is_paid,
                          cash_bills_behavior
                        )
                      "
                      style="
                        color: black;
                        background-color: pink;
                        padding: 1px;
                        margin: 2px;
                      "
                    >
                      !! Pending Payment !!
                    </span>
                    <button
                      class="btn btn-sm btn-danger button-touch"
                      v-if="service.attended != 1"
                      @click="removeTest(service.id)"
                    >
                      Delete Test
                    </button>
                  </td>
                </tr>
                <!-- ====================================== -->

                <tr v-if="services.length === 0">
                  <td colspan="6" class="text-center text-muted py-4">
                    No investigations ordered for this patient
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ConductLabtestModal
    v-if="show_add_lab_test_modal"
    @hide-create-test-model="hideCreateTestModel"
    :service_id="current_test"
  />

  <CreateServiceModal
    v-if="showAddServiceModal"
    :visitId="visit_id"
    @close-add-service-modal="showAddServiceModal = false"
  />

  <ViewLabResults
    v-if="showViewModal"
    :service_id="current_test"
    @close-view-result-modal="showViewModal = false"
  />
</template> 

<script>
import CreateServiceModal from "../../visits_management/add_patient_service_modal.vue";
import ConductLabtestModal from "../../visits_management/lab/add_lab_test_modal.vue";
import { generalApiRequest } from "../../../api/apiIndex.js";
import ViewLabResults from "../../visits_management/lab/view_lab_results.vue";
import { get_setting } from "../../../settings/get_setting.js";
import loader from "../dialysis/loader.vue";
import { open_service } from "../../../settings/get_setting.js";

// import PatientInfo from "../Patients/components/patient_biodata.vue";
// import CreateServiceModal from "./add_patient_service_modal.vue";
// import ConductLabtestModal from "./lab/add_lab_test_modal.vue";
// import { generalApiRequest } from "../../api/apiIndex.js";
// import ViewLabResults from "./lab/view_lab_results.vue";
// import { get_setting } from "../../settings/get_setting.js";
// import loader from "../special_clinics/dialysis/loader.vue";
// import { open_service } from "../../settings/get_setting.js";

import full_oncology_head from "./full_oncology_head.vue";

export default {
  name: "PatientInvestigations",
  components: {
    full_oncology_head,
    ConductLabtestModal,
    // PatientInfo,
    CreateServiceModal,
    ViewLabResults,
    loader,
  },
  data() {
    return {
      visit_id: this.$route.params.visit_id,

      show_add_lab_test_modal: false,
      patient_id: null,
      showAddServiceModal: false,
      services: [],
      current_test: "",
      showViewModal: false,
      cash_bills_behavior: 0,
      loading: false,
    };
  },
  methods: {
    open_service,
    navigate_loc(route) {
      window.location.href = route;
    },
    showViewTestModal(tid) {
      this.current_test = tid;
      this.showViewModal = true;
    },

    handleShowAddTestModal(tid) {
      this.current_test = tid;
      this.show_add_lab_test_modal = true;
      // You can pass the service info to the modal if needed
    },

    hideCreateTestModel() {
      this.show_add_lab_test_modal = false;
      window.location.reload();
    },

    showCreatePatientService() {
      this.showAddServiceModal = true;
    },

    async fetchServicesForVisit() {
      this.loading = true;
      const url = `services/for-visit/${this.visit_id}/2`;
      try {
        const response = await generalApiRequest(url, "GET", {}, 1);
        // console.log(response);

        this.services = response.data;

        const payment_setting = await get_setting("cash_bills_behavior");
        this.cash_bills_behavior = payment_setting.setting_value;
      } catch (error) {
        console.error("Error fetching services:", error);
      }
      this.loading = false;
    },

    async removeTest(serviceId) {
      const url = "services/delete/" + serviceId;
      const body = {};
      const res = await generalApiRequest(url, "GET", body, 1);
      if (res) {
        location.reload();
      }
    },

    editTest(serviceId) {
      this.current_test = serviceId;
      this.show_add_lab_test_modal = true;
    },

    async mountPastRecords() {
      const url = "get_all_visits_dates";
      const body = { visit_id: this.visit_id };
      const res = await generalApiRequest(url, "GET", body, 1);
      this.past_records = res.data;
      console.log(res.data);

      if (res.data.length > 0) {
        this.patient_id = res.data[0].patient_id;
      }
    },
  },
  mounted() {
    this.mountPastRecords();
    this.fetchServicesForVisit(); // Fetch services when the component is mounted
  },
};
</script>

<style scoped>
/* Card */
.investigations-card {
  margin-top: 20px;
  border-radius: 8px;
  border-left: 5px solid #0d6efd;
  border-top: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

/* Header */
.investigations-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #dee2e6;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.header-icon {
  font-size: 26px;
  color: #0d6efd;
}

/* Table */
.investigations-table {
  font-size: 0.95rem;
}

.investigations-table thead th {
  background: #fafbfc;
  font-weight: 600;
  color: #495057;
}

/* Type pills */
.type-pill {
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 0.75rem;
  font-weight: 600;
}

.type-lab {
  background: #e7f1ff;
  color: #0d6efd;
}

.type-xray {
  background: #f1f3f5;
  color: #495057;
}

.type-ct {
  background: #fff3cd;
  color: #856404;
}

.type-mri {
  background: #e2e3f3;
  color: #3f51b5;
}

/* Status dots */
.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.dot-ordered {
  background: #6c757d;
}

.dot-sample {
  background: #fd7e14;
}

.dot-reported {
  background: #0d6efd;
}

.dot-reviewed {
  background: #198754;
}

.status-text {
  font-size: 0.85rem;
}

/* Buttons */
.btn-light {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
}

.btn-light:hover {
  background: #e9ecef;
}

/* Responsive */
@media (max-width: 768px) {
  .investigations-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}
</style>
